import { render, staticRenderFns } from "./MediaKitLink.vue?vue&type=template&id=8b631874"
import script from "./MediaKitLink.vue?vue&type=script&lang=js"
export * from "./MediaKitLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports